import React, { SVGProps } from "react";

export default function JaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M37 39H3a2 2 0 01-2-2V3a2 2 0 012-2h34a2 2 0 012 2v34a2 2 0 01-2 2z"
        ></path>
        <path
          fill="#9262DD"
          d="M18.037 18.528C20.743 12.068 24.118 6.732 26.828 3H4a1 1 0 00-1 1v15.82c5.154-1.242 10.218-1.577 15.037-1.292m13.391 2.321c1.952.556 3.81 1.18 5.572 1.839v-11.02a61.487 61.487 0 00-5.572 9.18M14.126 31.6c-3.572.1-7.305.7-11.126 1.954V36a1 1 0 001 1h9.431c.139-1.84.38-3.64.695-5.4m13.092 1.728a42.52 42.52 0 00-.53 3.672H36a.982.982 0 00.373-.076c-2.694-1.35-5.773-2.627-9.155-3.596"
        ></path>
        <path
          fill="#FEFEFE"
          d="M10.099 6.807v4.53c0 .533-.059.981-.176 1.345-.116.363-.34.655-.67.875-.33.22-.805.33-1.425.33-.146 0-.325-.019-.535-.055a4.715 4.715 0 01-.604-.146l.109-1.349c.433.06.726.09.881.09.305 0 .51-.083.609-.25.101-.167.151-.44.151-.82v-4.55h1.66zm4.529 0l2.22 7h-1.74l-.4-1.37h-1.74l-.4 1.37h-1.74l2.22-7h1.58zm-.77 2.17h-.04l-.52 2.03h1.08l-.52-2.03z"
        ></path>
        <path
          fill="#E9E9E9"
          d="M37 0H3C1.346 0 0 1.346 0 3v34c0 1.653 1.346 3 3 3h34c1.654 0 3-1.347 3-3V3c0-1.654-1.346-3-3-3m0 1a2 2 0 012 2v34a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h34"
        ></path>
        <path
          fill="#F9828B"
          d="M18.05 26.58A44.18 44.18 0 003 28.196v3.412a40.924 40.924 0 0114.839-1.77c.879.07 1.676-.623 1.734-1.524a1.632 1.632 0 00-1.523-1.734M37 24.717a70.465 70.465 0 00-10.064-3.03 1.639 1.639 0 00-1.944 1.246c-.192.88.365 1.75 1.246 1.943 3.911.856 7.544 2.063 10.762 3.362v-3.521zM29.166 3c-3.041 4.051-7.292 10.562-10.33 18.689a1.632 1.632 0 103.059 1.143C25.328 13.646 30.507 6.483 33.315 3h-4.149zm-3.074 26.533a1.635 1.635 0 00-1.16-1.997 1.631 1.631 0 00-1.996 1.16A47.56 47.56 0 0021.49 37h3.282c.22-2.48.657-4.972 1.32-7.467"
        ></path>
        <path
          fill="#EA5A60"
          d="M36.918 3.606c.052.12.082.254.082.394v4.587c-3.523 4.466-7.915 11.196-10.407 19.408 3.81.944 7.308 2.26 10.407 3.69v3.6c-3.263-1.604-7.055-3.115-11.24-4.142l-3.19-.67a47.127 47.127 0 00-2.827-.4 50.31 50.31 0 00-1.1 6.927h-3.328c.193-2.466.547-4.87 1.054-7.182l.816-3.225c.276-.982.571-1.947.888-2.893-4.847-.325-9.94.034-15.073 1.418v-3.39c5.587-1.404 11.074-1.684 16.251-1.255l3.47.395c.912.133 1.816.28 2.703.45.047.01.098.025.146.035 3.428-7.981 8.196-14.172 11.348-17.747zM21.504 24.043a60.42 60.42 0 00-.912 2.84c.95.117 1.89.253 2.81.42.285-.954.59-1.894.918-2.81a56.826 56.826 0 00-2.816-.45z"
        ></path>
      </g>
    </svg>
  );
}
